import { Badge, Text } from '@mantine/core';

export type NoteAutosaveStatusValue = 'saved' | 'saving' | 'unsaved' | 'error';

const STATUS_COPY: Record<NoteAutosaveStatusValue, { label: string; color: string }> = {
  saved: { label: 'Saved', color: 'green' },
  saving: { label: 'Saving…', color: 'blue' },
  unsaved: { label: 'Unsaved changes', color: 'yellow' },
  error: { label: 'Unable to save. We’ll retry when changes are made.', color: 'red' },
};

export interface NoteAutosaveStatusProps {
  status: NoteAutosaveStatusValue;
}

export function NoteAutosaveStatus({ status }: NoteAutosaveStatusProps): JSX.Element {
  const { label, color } = STATUS_COPY[status];
  return (
    <Badge variant="light" color={color} size="sm" aria-live="polite">
      <Text span size="xs" inherit>
        {label}
      </Text>
    </Badge>
  );
}
